<template>
    <div id="app">
        <v-app id="inspire">
            <v-card v-model="show" color="#FFFF99">
                <v-card-title>
                    <v-icon large left>mdi-wrench-clock</v-icon>
                    <h6>Obligaciones Periódicas RRHH</h6>
                </v-card-title>
            </v-card>

            <v-data-table dense :headers="headers" :items="listado" locale="es-ar" class="elevation-1"
                :items-per-page="200">
                <template v-slot:item.fecha="{ item }">
                    <v-chip :color="getColor(item.fecha)">
                        {{ item.fecha }}
                    </v-chip>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="blue" class="mr-2" v-on="on" v-bind="attrs"
                                @click.stop="verPlanilla(item)">
                                mdi-eye
                            </v-icon>
                        </template>
                        <span>ver plan</span>
                    </v-tooltip>
                    <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                            <v-icon small color="purple" class="mr-2" v-on="on" v-bind="attrs"
                                @click.stop="editarPlanilla(item)">
                                mdi-pencil
                            </v-icon>
                        </template>
                        <span>editar plan</span>
                    </v-tooltip>
                </template>
            </v-data-table>
            <v-container>
                <v-row dense>
                    <v-col v-for="(item, i) in listadoobj" :key="i" cols="12" md="6" lg="4">
                        <v-card :color="colorCumplimiento(item.valoractual)">
                            <v-card-title>Objetivo: {{ item.codgral }}</v-card-title>

                            <v-card-text>
                                <div><strong>Descr.:</strong> {{ item.objetivo }}</div>
                                <div><strong>Tipo:</strong> {{ item.tipo }}</div>

                                <div>
                                    <strong>Meta:</strong>
                                    <pre class="meta">{{ item.meta }}</pre>
                                </div>

                                <div><strong>Indicador:</strong> {{ item.indicador }}</div>
                                <div><strong>Responsable:</strong> {{ item.responsable }}</div>
                                <div><strong>Cumplimiento:</strong> {{ item.cumplimiento }}%</div>
                                <div><strong>Valor Indic / Referencia:</strong> {{ item.valoractual }} / {{
                                    item.referencia }}</div>
                                <div><strong>Plan:</strong> {{ item.plan }}</div>
                                <div><strong>Observaciones:</strong> {{ item.observ }}</div>

                                <div>
                                    <strong>Fecha de Actualización:</strong>
                                    {{ item.fecha }}
                                </div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
            <VerPlanilla :visible="showPlanilla" :codgral="editedItem.codgral" :descr="editedItem.descr"
                @close="showPlanilla = false">
            </VerPlanilla>
            <EditarPlanilla :visible="showEditar" :codgral="editedItem.codgral" :descr="editedItem.descr"
                :entidad="editedItem.entidad" :frecuencia="editedItem.frecuencia" @close="showEditar = false">
            </EditarPlanilla>
        </v-app>
    </div>
</template>
<style>
.meta {
    white-space: pre-wrap;
    /* ← Para permitir varias líneas */
    font-family: inherit;
}
</style>
<script>
import moment from "moment";
import axios from "../../axios-auth";
import VerPlanilla from "../RRHH/Obligaciones/Listadohistorial.vue";
import EditarPlanilla from "../RRHH/Obligaciones/Editar.vue";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
    components: { VerPlanilla, EditarPlanilla },
    //components: { VerPlanilla },
    data: (vm) => ({
        usuario: null,
        now: moment(),
        diferencia: "",
        editedItem: {},
        editedIndex: -1,
        listado: [],
        listadoobj: [],
        showPlanilla: false,
        showEditar: false,

        headers: [
            {
                text: "Pago",
                align: "center",
                sortable: false,
                value: "descr",
            },
            { text: "Monto", value: "monto", sortable: false },
            { text: "Entidad", value: "entidad", sortable: false },
            { text: "Fecha Último Pago", value: "fechault", sortable: false },
            { text: "Fecha Próximo Pago", value: "fecha", sortable: false },
            { text: "Frecuencia", value: "frecuencia", sortable: false },
            { text: "Acciones", value: "actions", align: "center", sortable: false },
        ],
    }),

    computed: {
        show: {
            get() {
                this.cargarListados();
                return this.visible;
            },
            set(value) {
                if (!value) {
                    this.$emit("close");
                }
            },
        },
    },
    created() {
        this.usuario = this.$store.state.usuario.toString().trim();
        this.cargarListado();
    },
    mounted() {
        if (this.$store.state.usuario == "" || this.$store.state.usuario == null) {
            this.$store.dispatch("logout");
        } else {
            this.$store.state.sector = "RRHH";
            //  this.cargaraccidentes();
        }
    },
    methods: {

        getColor(fecha) {
            var Hoy = moment().format("DD/MM/YYYY");
            if (
                moment(fecha, "DD/MM/YYYY")
                    .fromNow()
                    .includes("ago")
            )
                return "red";
            else
                return "green";
        },

        cargarListados() {
            this.vaciarModels();
            let self = this;

            axios
                .get("/RRHH/ListadoObligacionesRRHH?", {
                })
                .then((response) => {
                    self.listado = response.data;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        verPlanilla(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showPlanilla = true;
        },
        editarPlanilla(item) {
            this.editedIndex = this.listado.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.showEditar = true;
        },

        vaciarModels() {
            this.listado = [];
            this.listadoobj = [];
        },

        colorCumplimiento(item) {
            if (item != null && item != "") {
                if (item == "0") {
                    return "red";
                }
                if (item == "100") {
                    return "green";

                }
                if (item.replace(",", ".") > 0 && item.replace(",", ".") < 100) {
                    return "yellow";
                }
            }
        },

        cargarListado() {
            this.loadtable = true;
            const codgral = "";
            const periodo = "";
            const objetivo = "";
            const meta = "";
            const indicador = "";
            const responsable = "";
            const area = "RRHH";
            const tipo = "";
            const asociado = "";

            let self = this;
            axios
                .get("/Indicadores/ListadoObjetivos?", {
                    params: {
                        codgral: codgral,
                        periodo: periodo,
                        objetivo: objetivo,
                        indicador: indicador,
                        responsable: responsable,
                        meta: meta,
                        asociado: asociado,
                        area: area,
                        tipo: tipo,

                    },
                })
                .then((response) => {
                    self.listadoobj = response.data;
                    self.loadtable = false;
                    console.log(self.listado)
                })
                .catch((error) => {
                    self.listadoobj = [];
                    console.log(error);
                });
        },
    },
};
</script>
